import { connect } from 'react-redux';
import OrderViewModal from '../components/OrderViewModal';
import { getMemberType } from '../selectors/converterSelector';

const mapStateToProps = function(store) {
    return {
        memberType: getMemberType(store),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {};
};
const ConnectedOrderViewModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderViewModal);

export default ConnectedOrderViewModal;
